import { call, put, takeLatest } from 'redux-saga/effects';

import { getConfig } from '../../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getConfig);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* configSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
